import { jsx as _jsx } from "react/jsx-runtime";
import noop from "lodash/noop";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const CardEllipsisMenu = (param)=>{
    let { actionSheetTestId, menuProps, onMenuChange = noop, title, className, trigger } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
            "data-testid": actionSheetTestId,
            isTitleHidden: true,
            onChange: onMenuChange,
            title: title,
            trigger: trigger,
            ...menuProps
        })
    });
};
